import { Link } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';

/**
 * EAA-1814 (S3 rebuild — canonical frame 09): "Cấp tài khoản 7 ngày" (frame 09
 * lines 911-990) — a 7-day bar chart of new-account provisioning, labelled
 * T2..CN.
 *
 * NOT BUILT with real bars: `GET /dashboard`'s `kpis.provisioning` is a
 * current-moment snapshot (`{synced, pending, error}` counts over active
 * `Assignment` rows — see `useDashboard.ts` / `DashboardService._kpis`), not
 * a day-by-day time series. There is no field anywhere in the response this
 * chart could honestly bind to. The card shell is kept for layout parity;
 * the body renders the real snapshot instead of a fabricated 7-day trend —
 * still useful (today's synced/pending/error mix), just not what the frame
 * drew, and clearly labelled as such rather than presented as the 7-day view.
 *
 * Gated on `console.accounts.issue` — the capability that owns account
 * provisioning.
 */
export function HomeAllocationChart({
    can,
    provisioning,
}: {
    can: (key: string) => boolean;
    provisioning?: { synced: number; pending: number; error: number };
}) {
    const { t } = useTranslation();
    if (!can('console.accounts.issue')) {
        return null;
    }

    return (
        <div className="portal-home-card portal-home-chart-card">
            <div className="portal-home-card-head-text">
                <h3>{t('home.allocationChart.title')}</h3>
                <span className="portal-home-card-sub">{t('home.allocationChart.subtitle')}</span>
            </div>
            {provisioning ? (
                <div className="portal-home-provisioning-snapshot">
                    <div className="portal-home-provisioning-row">
                        <span className="portal-home-provisioning-dot is-ok" aria-hidden="true" />
                        <span>{t('home.allocationChart.syncedLabel')}</span>
                        <strong>{provisioning.synced}</strong>
                    </div>
                    <div className="portal-home-provisioning-row">
                        <span className="portal-home-provisioning-dot is-pending" aria-hidden="true" />
                        <span>{t('home.allocationChart.pendingLabel')}</span>
                        <strong>{provisioning.pending}</strong>
                    </div>
                    <div className="portal-home-provisioning-row">
                        <span className="portal-home-provisioning-dot is-danger" aria-hidden="true" />
                        <span>{t('home.allocationChart.errorLabel')}</span>
                        <strong>{provisioning.error}</strong>
                    </div>
                </div>
            ) : (
                <div className="portal-home-unavailable">
                    <span className="portal-home-unavailable-note">
                        {/* EAA-1845: Trans keeps the sentence whole for translators;
                            see the matching note in HomeAppCoverage.tsx. */}
                        <Trans
                            i18nKey="home.allocationChart.unavailableNote"
                            components={{
                                code: <code />,
                                link: (
                                    <Link
                                        to="/console/accounts"
                                        className="portal-home-unavailable-link"
                                    />
                                ),
                            }}
                        />
                    </span>
                </div>
            )}
        </div>
    );
}

export default HomeAllocationChart;
